// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputWithIcon-inputWrapper {
  position: relative;
  border: 1px solid var(--gray_light1);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.InputWithIcon-inputWrapper .input {
  border: none;
  padding: 8px;
  width: 100%;
  color: var(--gray_dark2);
}
.InputWithIcon-inputWrapper .iconWrapper {
  height: 38px;
  align-self: center;
  border-right: 0;
  padding-left: 8px;
  display: flex;
}
.InputWithIcon-inputWrapper .iconWrapper .suggestionIcon {
  height: 40%;
  align-self: center;
  justify-self: center;
}
.InputWithIcon-inputWrapper:focus-within {
  border-color: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/components/InputWithIcon/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;AACJ;AAEE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAAJ;AAEI;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;AAAN;AAIE;EACE,sCAAA;AAFJ","sourcesContent":[".InputWithIcon-inputWrapper {\n  position: relative;\n  border: 1px solid var(--gray_light1);\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  .input {\n    border: none;\n    padding: 8px;\n    width: 100%;\n    color: var(--gray_dark2);\n  }\n\n  .iconWrapper {\n    height: 38px;\n    align-self: center;\n    border-right: 0;\n    padding-left: 8px;\n    display: flex;\n\n    .suggestionIcon {\n      height: 40%;\n      align-self: center;\n      justify-self: center;\n    }\n  }\n\n  &:focus-within {\n    border-color: var(--color_primary_500);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
